import * as React from 'react'
import { IMobilityOptionCategoryObject } from '../../types/index'

export interface IMobilityOptionsCategoryItemProps {
  category: IMobilityOptionCategoryObject
  onRemove: (category: IMobilityOptionCategoryObject) => void
}

const MobilityOptionsCategoryListItem = ({ category, onRemove }: IMobilityOptionsCategoryItemProps) => {
  const toRemove = () => {
    onRemove(category)
  }

  return (
    <div className='mt1'>
      <div className='MobilityOptionsCategoryListItem flex justify-between pl3'>
        <span className='MobilityOptionsCategoryListItemName'>{category.name}</span>
        <button type='button' onClick={toRemove} className='btn bg-white rounded font-light-grey mr2'>
          x
        </button>
      </div>
    </div>
  )
}

export default MobilityOptionsCategoryListItem



// WEBPACK FOOTER //
// ./src/components/mobility-options/MobilityOptionsEditCategoryModalListItem.tsx